import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import UserLink from '@wix/da-shared-react/pkg/User/Link';
import s from './Commentable.scss';

export interface Props {
  title: string;
  url?: string;
  author?: PapiUser;
}

const GenericCommentable: React.FC<Props> = ({ author, title, url }) => {
  const { t } = useTranslation();

  const titleNode = url ? (
    <a className={s['link']} href={url}>
      {title}
    </a>
  ) : (
    <span>{title}</span>
  );

  let inner;
  if (author) {
    inner = t('commentable.header.genericWithAuthor', {
      postProcess: ['reactPostprocessor', 'featureBrancher'],
      title: titleNode,
      author: <UserLink className={s['link']} user={author} />,
    });
  } else {
    inner = t('commentable.header.generic', {
      postProcess: ['reactPostprocessor', 'featureBrancher'],
      title: titleNode,
    });
  }

  return <h1 className={s['text']}>{inner}</h1>;
};
GenericCommentable.displayName = 'GenericCommentable';

export default GenericCommentable;
